// Simplified palette for presets

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: '#C8FACD',
  light: '#5BE584',
  main: '#00AB55',
  dark: '#007B55',
  darker: '#005249',
  contrastText: '#FFFFFF',
};

const PRIMARY_DARK = {
  lighter: '#C8FACD',
  light: '#5BE584',
  main: '#00AB55',
  dark: '#007B55',
  darker: '#005249',
  contrastText: '#FFFFFF',
};

export default function palette(mode) {
  const isLight = mode === 'light';

  return {
    mode,
    primary: isLight ? PRIMARY : PRIMARY_DARK,
    grey: GREY,
    text: {
      primary: isLight ? GREY[800] : GREY[100],
      secondary: isLight ? GREY[600] : GREY[500],
      disabled: GREY[500],
    },
    background: {
      paper: isLight ? '#FFFFFF' : GREY[800],
      default: isLight ? '#FFFFFF' : GREY[900],
      neutral: isLight ? GREY[200] : GREY[700],
    },
    divider: isLight
      ? 'rgba(145, 158, 171, 0.24)'
      : 'rgba(145, 158, 171, 0.24)',
  };
}
